import { Controller } from "stimulus"

// Swaps a field's placeholder to match the option someone picked:
//   <input type="radio" data-action="input-hint#apply" data-input-hint-text="Where did you get stuck?">
//   <textarea data-input-hint-target="input"></textarea>
export default class extends Controller {
  static targets = ["input"]

  apply(event) {
    const text = event.currentTarget.dataset.inputHintText
    if (text && this.hasInputTarget) this.inputTarget.placeholder = text
  }
}
